"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
const validation_1 = require("./validation");
class ApiError extends Error {
    constructor(message, status, validationErrors, interlayerErrors) {
        super(message);
        this.status = status;
        this.validationErrors = validationErrors;
        this.interlayerErrors = interlayerErrors;
    }
    getLocalizedValidationErrors() {
        var _a;
        if (this.status === 400 && ((_a = this.validationErrors) === null || _a === void 0 ? void 0 : _a.length)) {
            return (0, validation_1.localizeErrors)(this.validationErrors);
        }
        return {};
    }
}
exports.ApiError = ApiError;
//# sourceMappingURL=error.js.map